export default __webpack_public_path__ + "static/media/03_MINE_03-min.0e7dbf57.jpg";